import { LeadPageContext } from "@/modules/lead-page/context/lead-page.context";
import React, { useContext, useState } from "react";

const emailRegex = /^[^\s@]{1,64}@[^\s@]{1,255}\.[^\s@]{1,63}$/;

const useEditEmail = () => {
  const { lead } = useContext(LeadPageContext);
  const [editEmailModalOpen, setEditEmailModalOpen] = useState(false);
  const [email, setEmail] = useState(lead?.data?.lead?.email || null);
  const [formatError, setFormatError] = useState(false);
  const [showError, setShowError] = useState(false);

  const handleChangeEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);

    if (!emailRegex.test(e.target.value)) {
      setFormatError(true);
      setShowError(true);
    } else {
      setFormatError(false);
      setShowError(false);
    }
  };

  const handleFormatError = () => {
    return !formatError;
  };

  const resetFormatError = () => {
    setFormatError(false);
    setShowError(false);
  };

  return {
    email: {
      editEmailModalOpen,
      setEditEmailModalOpen,
      handleChangeEmail,
      handleFormatError,
      resetFormatError,
      state: email,
      setState: setEmail,
      value: lead?.data?.lead?.email || "Not Set",
      formatError,
      showError,
    },
  };
};

export default useEditEmail;
